import {ComponentProps} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Card} from "antd";
import * as api from "../../apis/rebate";
import useAntTable from "../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import DatePicker from "../../components/DatePicker";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import {PlatformType} from "../../utils/constants";



function RebateSummary(props:ComponentProps<any>) {
    const platform = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.platform ?? PlatformType.Dealer;
    const {tableProps, search, form} = useAntTable(api.getRebateSummary, {});

    const columns:StandardColumnsType = [
        {
            dataIndex: 'dealerName',
            title: '客户名称'
        },
        {
            dataIndex: 'openingAmount',
            title: '期初金额'
        },
        {
            dataIndex: 'rebateAmount',
            title: '返利额度'
        },
        {
            dataIndex: 'usedAmount',
            title: '使用金额'
        },
        {
            dataIndex: 'cleanedAmount',
            title: '清除金额'
        },
        {
            dataIndex: 'remainingAmount',
            title: '剩余额度'
        }
    ];
    const adminColumns:StandardColumnsType = [
        {
            dataIndex: 'dealerName',
            title: '客户名称/编码',
            search: true
        }
    ];

    const commonSearchColumns:StandardColumnsType = [
        {
            dataIndex: 'startDate',
            title: '开始日期',
            search: {
                valueType: 'date',
                valueRender: <DatePicker style={{width: '100%'}}/>
            }
        },
        {
            dataIndex: 'endDate',
            title: '结束日期',
            search: {
                valueType: 'date',
                valueRender: <DatePicker style={{width: '100%'}}/>
            }
        }
    ];
    const searchColumns = platform ==PlatformType.Admin?[...adminColumns, ...commonSearchColumns]:[...commonSearchColumns];

    return <PageHeaderLayout>
            <StandardTable {...tableProps} submit={search.submit} columns={columns} extSearchColumns={searchColumns} form={form} search={search}/>
    </PageHeaderLayout>
}

export default RebateSummary